<template>
  <div class="body">
    <Home-Header :navindex="5"></Home-Header>
    <!-- <Home-Nav :navindex="2"></Home-Nav> -->
    <Home-Main></Home-Main>
    <Home-Safe></Home-Safe>
    <Home-Floatbar></Home-Floatbar>
    <Home-Footer></Home-Footer>
    <Home-Footerfrom></Home-Footerfrom>
    <!-- <a id="newBridge-left"  href="http://pkt.zoosnet.net/LR/Chatpre.aspx?id=PKT58642380&lng=cn"  rel='nofollow' target="_blank" ></a> -->

  </div>
</template>

<script>
import HomeHeader from '../common/Header'
import HomeMain from './components/Main'
import HomeSafe from '../common/Safe'
import HomeFloatbar from '../common/Floatbar'
import HomeFooter from '../common/Footer'
import HomeFooterfrom from '../common/Footerfrom'
export default {
  name: 'News',
  metaInfo: {
    title: '代理记账公司新闻资讯-上海机巧科技有限公司',
    meta: [
      { name: 'keywords', content: '上海代理记账_财务法规' },
      { name: 'description', content: '上海机巧科技新闻资讯栏目及时更新财务新政策、财务法规、代理记账行业动态、财务代办新规定等相关内容,让企业财务人员及时了解财务法规.' }
    ]
  },
  components: {
    HomeHeader, HomeMain, HomeSafe, HomeFloatbar, HomeFooter, HomeFooterfrom
  },
  data () {
    return {
    }
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/News/News.vue